import { useState } from "react";
import { useTranslation } from "react-i18next";

const useLocale = () => {
  const { i18n } = useTranslation();
  const [locale, setLocale] = useState(i18n.language);

  i18n.on("languageChanged", (newLocale) => setLocale(newLocale));

  return locale;
};

export default useLocale;
